import { BulkActionGlobalColumnsValidationSchema } from "@/common/schemas/bulkActions/globalColumns.schema";

export const bulkActionsGlobalColumnsParser = (globalColumns: BulkActionGlobalColumnsValidationSchema) => {
  for (const columnKey in globalColumns) {
    globalColumns[columnKey] = typeof globalColumns[columnKey] === 'string' ? globalColumns[columnKey] : globalColumns[columnKey]?.value;
  }

  return globalColumns;
};
